import 'css-chunksrc/client/scenes/projectExternalLinks/styles.scss';export default {
  "projectExternalLinks": "_projectExternalLinks_1xll0_1",
  "link": "_link_1xll0_8",
  "form": "_form_1xll0_17",
  "title": "_title_1xll0_21",
  "main": "_main_1xll0_31",
  "button": "_button_1xll0_43",
  "smallButton": "_smallButton_1xll0_60",
  "iconBox": "_iconBox_1xll0_75",
  "icon": "_icon_1xll0_75",
  "closeIconBox": "_closeIconBox_1xll0_89",
  "closeIcon": "_closeIcon_1xll0_89"
};